import { TabContext, TabList } from "@mui/lab"
import { Tab } from "@mui/material"
import { SyntheticEvent, useState } from "react"
import { EvidenceTabEnum } from "../../enum"
import { useTranslation } from "react-i18next"
import { EvidenceTabProps } from "./types"
import { useStyles } from "./styles"

function EvidenceTab({ tabList, children }: EvidenceTabProps) {
    const { t } = useTranslation()
    const styles = useStyles()
    const [value, setValue] = useState<EvidenceTabEnum>(EvidenceTabEnum.ITEM)
    function changeTab(_: SyntheticEvent<Element, Event>, value: any) {
        setValue(value)
    }
    return (
        <TabContext value={value}>
            <TabList variant="fullWidth" sx={styles.tabList} onChange={changeTab}>
                { tabList.map(tab => (<Tab  value={tab.value} label={t(tab.label)} />)) }
            </TabList>

            {children}
        </TabContext>
    )
}

export { EvidenceTab }